<template>
  <imports-template
    ref='template'
    :canImport='canImport'
    :canExport='canExport'
    currentPage='GetImportSecurityDepositsData'
    @downloadTemplate='downloadTemplate'
    @clearImportData='clearImportData'
    @saveUpload='saveUpload'
    @addNew='addNewItem'
    @submit='submit'>
    <template v-slot:header>
      <drop-down
        :selectedValue="{ text: selectedPropertyName }"
        :items="'Properties'"
        :label="'Property'"
        :multiple='false'
        width="200px"
        hideDetails
        rules="required"
        class="ml-2 mr-3"
        :getParams="{ IncludeIncomplete: false, IncompleteOnly: false }"
        @itemSelected="selectProperty">
      </drop-down>
      <date-picker
        :label="'Conversion Date'"
        class="mt-5"
        hideDetails
        :defaultNull="true"
        rules="required"
        :initialDate="conversionDate"
        @dateSelected="setDate">
      </date-picker>
    </template>
    <template v-slot:body>
      <data-table
        :headers="headers"
        :tableData="getData"
        @itemDeleteRequested="deleteItem"
        @unlockEditing="unlockEdit"
        @dataChanged="save"
        @canceled="cancel"
        class="mx-6"
        :noData="'Please select an import template to upload.'">
      </data-table>
      <v-layout row mt-1 v-if='showWarning'>
        <v-icon small color="var(--v-resRed-base)">warning</v-icon>
        <span class='resRed-base--text'>
            {{ warningMessage }}
        </span>
      </v-layout>
    </template>
  </imports-template>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as fileDownload from '../../../../utility/fileDownloader'
import * as validation from '../../../../utility/validation'
import DataTable from '../../../BaseComponents/Table'
import DropDown from '../../../BaseComponents/DropDown'
import DatePicker from '../../../BaseComponents/DatePicker'
import ImportsTemplate from './ImportsTemplate'
export default {
  components: {
    DataTable,
    DropDown,
    DatePicker,
    ImportsTemplate
  },
  data () {
    return {
      files: {},
      selectedProperty: undefined,
      selectedPropertyName: undefined,
      importDialog: false,
      confirmDialog: false,
      conversionDate: null
    }
  },
  methods: {
    ...mapActions(['fetchData', 'changeData', 'initializeStoreItem', 'fetchDropdown', 'addNew']),
    selectProperty (val) {
      if (val !== null) {
        this.selectedProperty = val.value
        this.selectedPropertyName = val.text
      } else {
        this.selectedProperty = null
        this.selectedPropertyName = null
      }
    },
    setDate (val) {
      this.conversionDate = val
    },
    deleteItem (item) {
      this.$refs.template.deleteItem(item, this.getData, 'ImportChargeCodeMappings')
    },
    unlockEdit (item) {
      this.$refs.template.unlockEdit(item, this.getData)
    },
    cancel (item) {
      this.$refs.template.cancelEdit(item, this.getData, 'ImportChargeCodeMappings')
    },
    save (item) {
      this.$refs.template.save(item)
    },
    addNewItem () {
      this.addNew({
        currentPage: 'GetImportSecurityDepositsData',
        newItem: {
          lease: { text: null, value: null },
          space: { text: null, value: null },
          chargeCode: { text: null, value: null },
          bankAccount: { text: null, value: null },
          checkNumber: null,
          amount: null,
          actionColumn: { delete: true, edit: true },
          readonly: false,
          new: true,
          errorToolTip: { hasIcon: false, tooltip: null, value: '' }
        }
      })
    },
    downloadTemplate () {
      this.fetchData({ newPage: 'ImportSecurityDeposits', params: { Property: this.selectedProperty } }).then(() => {
        let file = this.currentData('ImportSecurityDeposits')
        let bufferArray = fileDownload.convertArrayBuffer(file.fileContent)
        let fileName = file.fileName.split('.')[0]
        fileName += '-' + this.selectedPropertyName + '.xlsx'
        fileDownload.createDownloadFile(bufferArray, fileName)
      }).catch(error => { console.log(error.response) })
    },
    saveUpload (item) {
      this.fetchDropdown({ newDropdown: 'Leases', params: { LeaseStatus: 0, PropertyId: this.selectedProperty } }).catch(error => { console.log(error.response) })
      this.fetchDropdown({ newDropdown: 'Property Spaces', params: { Property: this.selectedProperty } }).catch(error => { console.log(error.response) })
      this.fetchDropdown({ newDropdown: 'Bank Account', params: { Company: this.selectedProperty } }).catch(error => { console.log(error.response) })
      this.fetchDropdown({ newDropdown: 'Filtered Charge Codes', params: { Property: this.selectedProperty } }).then(() => {
        this.changeData({ currentPage: 'GetImportSecurityDepositsData', newData: item, updateItem: {} }).then(() => {
          this.$refs.template.cancel()
        })
      }).catch(error => { console.log(error.response) })
    },
    submit () {
      this.changeData({ currentPage: 'ImportSecurityDeposits', newData: { Property: this.selectedProperty, Date: this.conversionDate, SecurityDeposits: this.getData } }).then(() => {
        this.$refs.template.cancelImport()
      }).catch(error => { console.log(error.response) })
    },
    clearImportData () {
      this.initializeStoreItem('GetImportSecurityDepositsData')
    }
  },
  computed: {
    ...mapGetters(['currentData', 'currentHeaders', 'currentDropdown']),
    headers () {
      let items = JSON.parse(JSON.stringify(this.currentHeaders('GetImportSecurityDepositsData')))
      let validation = items.splice(items.findIndex(x => x.value === 'errorToolTip'), 1)
      return validation.concat(items)
    },
    rawData () {
      return this.currentData('GetImportSecurityDepositsData')
    },
    getData () {
      let items = this.rawData
      let leases = this.currentDropdown('Leases')
      let leasesLength = leases.length
      let spaces = this.currentDropdown('Property Spaces')
      let spacesLength = spaces.length
      let chargeCodes = this.currentDropdown('Filtered Charge Codes')
      let chargeCodesLength = chargeCodes.length
      let bankAccounts = this.currentDropdown('Bank Account')
      let bankAccountsLength = bankAccounts.length
      items.forEach(item => {
        if (leasesLength > 0 && validation.hasValue(item.lease) && validation.hasValue(item.lease.text)) {
          item.lease = leases.find(x => {
            if (validation.hasValue(x.text)) {
              return x.text.toLowerCase() === item.lease.text.toLowerCase()
            }
          })
        }
        if (spacesLength > 0 && validation.hasValue(item.space) && validation.hasValue(item.space.text)) {
          item.space = spaces.find(x => {
            if (validation.hasValue(x.text)) {
              return x.text.toLowerCase() === item.space.text.toLowerCase()
            }
          })
        }
        if (chargeCodesLength > 0 && validation.hasValue(item.chargeCode) && validation.hasValue(item.chargeCode.text)) {
          item.chargeCode = chargeCodes.find(x => {
            if (validation.hasValue(x.text)) {
              return x.text.toLowerCase() === item.chargeCode.text.toLowerCase()
            }
          })
        }
        if (bankAccountsLength > 0 && validation.hasValue(item.bankAccount) && validation.hasValue(item.bankAccount.text)) {
          item.bankAccount = bankAccounts.find(x => {
            if (validation.hasValue(x.text)) {
              return x.text.toLowerCase() === item.bankAccount.text.toLowerCase()
            }
          })
        }
        let errors = validation.validateValue(item, [
          { value: 'lease', required: true },
          { value: 'space', required: true },
          { value: 'chargeCode', required: true },
          { value: 'bankeAccount', required: true },
          { value: 'checkNumber', maxLength: 20 },
          { value: 'amount', required: true, positive: true }
        ], items)
        validation.handleErrorToolTip(item, errors)
      })
      return items
    },
    canExport () {
      if (validation.hasValue(this.selectedProperty) &&
      validation.hasValue(this.conversionDate)) {
        return true
      }
      return false
    },
    canImport () {
      if (this.getData.length > 0 && !this.showWarning) {
        return true
      }
      return false
    },
    warningMessage () {
      return this.getData.filter(x => x.errorToolTip.hasIcon === true).length + ' row(s) have errors. Please fix these to continue.'
    },
    showWarning () {
      return this.getData.filter(x => x.errorToolTip.hasIcon === true).length > 0
    }
  },
  beforeDestroy () {
    this.clearImportData()
  }
}
</script>
